/**
 * Tipos de Proyecto — catalogo delegado al asistente.
 *
 * Era un ABM de tres campos (code / label / sort_order) que se toca una vez por
 * trimestre y que ademas incumplia el estandar de listas del repo (#29). Las
 * tres acciones que hacia estan cubiertas por tools ya registradas:
 * `list_project_types`, `create_project_type` y `update_project_type`
 * (esta ultima cubre renombrar, reordenar y activar/desactivar).
 *
 * Lo unico que se perdio es el DELETE duro, que no tiene tool. No se repuso a
 * proposito: `projects.project_type_id` es FK `ON DELETE SET NULL`, asi que
 * borrar un tipo desvinculaba en silencio los proyectos historicos que lo
 * usaban. Desactivar hace lo que el admin realmente quiere (sacarlo del
 * selector) sin tocar el historial.
 *
 * El componente sigue exportandose igual porque lo monta ProjectsUnifiedView
 * como pestana "Tipos de Proyecto".
 *
 * @module pages/settings/ProjectTypesSettings
 */

import React from 'react';
import CatalogoDelegadoPanel from './CatalogoDelegadoPanel';

const ProjectTypesContent = () => (
  <CatalogoDelegadoPanel
    titulo="Los tipos de proyecto los administra el asistente"
    intro="Pedíselo por chat y queda listo en el momento: no hace falta pasar por acá."
    ejemplos={[
      'Agregá el tipo de proyecto Mantenimiento preventivo con código MP',
      'Desactivá el tipo de proyecto Instalación',
      'Mostrame todos los tipos de proyecto, incluidos los inactivos',
    ]}
    nota="Los tipos activos son los que aparecen en el selector al armar una cotización, y su código es el que sale en el número de proyecto (ej: 108-RL-M-0726)."
  />
);

export default ProjectTypesContent;
